import Vue from 'vue'
import Router from 'vue-router'
import zbNotice from '@/views/zbNotice.vue'
import zbResultNotice from '@/views/zbResultNotice.vue'
Vue.use(Router)
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'zbNotice',
            component: zbNotice,
        },
        // 新增：匹配 /随机ID 的动态路由
        {
            path: '/zbResultNotice',
            name: 'zbResultNotice',
            component: zbResultNotice,
        }
    ]
})